<h3 mat-dialog-title>{{ 'Add ' + (data?.onlyDepositAccounts ? 'Deposit ' : '') + 'Bank Account' }}</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>

    <app-bank-account-properties
        #propertiesForm
        [onlyDepositAccounts]="data?.onlyDepositAccounts"></app-bank-account-properties>

</mat-dialog-content>


<mat-dialog-actions>
    <button [attr.aria-label]="'cancel'" (click)="closeDialog()" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="saveAccount()"
            [attr.aria-label]="'save account'"
            [disabled]="isSaving"
            class="btn btn-primary"
            type="button">Save Bank Account
    </button>
</mat-dialog-actions>
